import React from "react";
import { alpha } from "@mui/material/styles";
import { Box, ButtonBase, Chip, Stack, Typography } from "@mui/material";
import { formatTime } from "./agendaDateUtils";

export default function AgendaItemCard({ item, color, onClick }) {
  return (
    <ButtonBase
      onClick={() => onClick?.(item)}
      sx={{
        width: "100%",
        borderRadius: 3,
        textAlign: "left",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          width: "100%",
          p: 2,
          borderRadius: 3,
          border: `1px solid ${alpha(color, 0.28)}`,
          background: `linear-gradient(135deg, ${alpha(color, 0.18)} 0%, ${alpha(color, 0.08)} 100%)`,
          boxShadow: `inset 4px 0 0 ${color}`,
        }}
      >
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={1}>
          <Box>
            <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
              {item.title}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {item.subtitle || item.source}
            </Typography>
          </Box>
          <Chip label={item.status} size="small" />
        </Stack>

        <Typography variant="body2" sx={{ mt: 1 }}>
          {formatTime(item.starts_at)} - {formatTime(item.ends_at)}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {item.location || "Not specified"}
        </Typography>
      </Box>
    </ButtonBase>
  );
}
